__webpack_require__.p = "/simple-twitter/";